import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from './dialog';

const BadgePreviewDialog = ({ badge, isOpen, onClose }) => {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent
                className="sm:max-w-md max-h-[90vh] overflow-y-auto"
                style={{
                    maxWidth: 'min(90vw, 28rem)',
                    padding: 'clamp(0.75rem, 3vw, 1.5rem)',
                    zIndex: 10002
                }}
                overlayStyle={{ zIndex: 10001 }}
            >
                <DialogHeader>
                    <DialogTitle className="text-center text-lg sm:text-xl font-bold text-gray-800">
                        {badge?.name}
                    </DialogTitle>
                    {badge?.description && (
                        <DialogDescription className="text-center text-sm sm:text-base text-gray-500 mt-2">
                            {badge.description}
                        </DialogDescription>
                    )}
                </DialogHeader>
                <div className="flex items-center justify-center p-3 sm:p-6">
                    {badge && (
                        <img
                            src={badge.imageUrl}
                            alt={badge.name}
                            className="w-full h-auto rounded-lg drop-shadow-lg"
                            style={{
                                maxWidth: 'min(100%, 320px)',
                                maxHeight: 'clamp(200px, 50vw, 320px)',
                                objectFit: 'contain'
                            }}
                        />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default BadgePreviewDialog;
